import React from 'react'

// Elements
import ParseContent from 'components/shared/ParseContent'

interface TextProps {
  // eslint-disable-next-line
  fields: GatsbyTypes.WpPage_Flexcontent_Flex_Text
}

const Text: React.FC<TextProps> = ({ fields }) => (
  <section className="bg-background">
    <div className="container py-5">
      <ParseContent className="text-text" content={fields?.description || ''} />
    </div>
  </section>
)

export default Text
